import React, { useState } from 'react';
import './Reviews.css';
import Seo from '../components/Seo';

const REVIEWS = [
  { name: 'John D.',     stars: 5, service: 'Ceramic Coating',    date: 'Mar 2025', text: 'Absolutely incredible work. My truck looks better than the day I bought it. The ceramic coating is flawless and the hydrophobic effect is unreal. Cardona is the only detailer I\'ll ever use.' },
  { name: 'Carlos R.',   stars: 5, service: 'Interior Deep Clean', date: 'Jan 2025', text: 'I have two kids and a dog — my car was a disaster. They removed stains I thought were permanent and got rid of every smell. I cried a little when I saw it. Worth every penny.' },
  { name: 'Sofia M.',    stars: 5, service: 'Exterior Wash & Wax', date: 'Dec 2024', text: 'Super professional and came right to my apartment building. No hassle at all. The wax they use is incredible — water beads off like crazy. Will definitely book again next month.' },
  { name: 'Luis P.',     stars: 4, service: 'Engine Bay Cleaning', date: 'Nov 2024', text: 'Engine looks cleaner than it has in years. They were careful around all the electrical components, which I appreciated. Only minor thing — took a bit longer than quoted, but quality was great.' },
  { name: 'Andrea V.',   stars: 5, service: 'Full Detail Combo',   date: 'Oct 2024', text: 'Booked the interior + exterior combo for my BMW before selling it. The buyer literally offered me more money because of how good it looked. Best investment ever.' },
];

export default function Reviews() {
  const [filter, setFilter] = useState(0);

  const filtered = filter === 0 ? REVIEWS : REVIEWS.filter(r => r.stars === filter);
  const avg = (REVIEWS.reduce((a, r) => a + r.stars, 0) / REVIEWS.length).toFixed(1);

  return (
    <div className="reviews-page">
      <Seo
        title="Customer Reviews | Cardona Auto Detailing"
        description="See what our customers say about Cardona Auto Detailing's mobile car detailing in Cookeville and Algood, TN."
        path="/reviews"
      />
      <div className="page-header">
        <div className="page-header-bg rev-bg"></div>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <p className="section-label">Client Testimonials</p>
          <h1 className="section-title">REVIEWS</h1>
        </div>
      </div>

      <section className="page-section">
        <div className="container">
          {/* Summary */}
          <div className="reviews-summary">
            <div className="summary-score">
              <span className="score-num">{avg}</span>
              <div className="summary-right">
                <div className="stars-lg" role="img" aria-label={`${avg} out of 5 stars`}>{'★'.repeat(5)}</div>
                <p>{REVIEWS.length} reviews</p>
              </div>
            </div>
            <div className="summary-bars">
              {[5,4,3,2,1].map(n => {
                const count = REVIEWS.filter(r => r.stars === n).length;
                const pct = Math.round((count / REVIEWS.length) * 100);
                return (
                  <div className="bar-row" key={n}>
                    <span>{n}★</span>
                    <div className="bar-track">
                      <div className="bar-fill" style={{ width: `${pct}%` }}></div>
                    </div>
                    <span className="bar-count">{count}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Filter */}
          <div className="reviews-filter">
            <span>Filter:</span>
            {[0,5,4,3].map(n => (
              <button
                key={n}
                className={`filter-btn ${filter === n ? 'active' : ''}`}
                onClick={() => setFilter(n)}
              >
                {n === 0 ? 'All' : `${n} Stars`}
              </button>
            ))}
          </div>

          {/* Cards */}
          <div className="reviews-grid">
            {filtered.map((r, i) => (
              <div className="rev-card" key={i}>
                <div className="rev-card-top">
                  <div className="rev-avatar">
                    {r.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <strong className="rev-name">{r.name}</strong>
                    <p className="rev-meta">{r.service} · {r.date}</p>
                  </div>
                  <div className="rev-stars" role="img" aria-label={`${r.stars} out of 5 stars`}>{'★'.repeat(r.stars)}</div>
                </div>
                <p className="rev-text">"{r.text}"</p>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <p style={{ color: 'var(--gray-3)', textAlign: 'center', padding: '40px 0' }}>
              No reviews for this rating yet.
            </p>
          )}

          {/* CTA */}
          <div className="reviews-cta-box">
            <h3>Happy with your detail? Leave us a review!</h3>
            <p>Your feedback helps us grow and helps other car owners find us.</p>
            <a
              className="btn-primary"
              href="https://g.page/r/YOUR_GOOGLE_REVIEW_LINK"
              target="_blank"
              rel="noopener noreferrer"
            >
              Leave a Google Review →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
